module.exports = __webpack_public_path__ + "images/home-slides/gallery.7d75d28808aba22d6a266f04ac204c07.jpg";